<template>
    <UIExampleContainer :componentId="'Statistic'" :name="'Statistic'" :vueComponent="vueComponent" :vueCode="vueCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>
</template>

<script>
    import { defineComponent } from 'vue';
    import { default as UIExampleContainer } from '../../UIExampleContainer.vue';
    import { default as ExampleComponent } from './Example.vue';
    import ExampleCode from '!!raw-loader!./Example.vue';

    export default defineComponent({
        name: "Statistic",
        components: {
            UIExampleContainer
        },
        setup(_props, _context) {
            return {
                vueComponent: ExampleComponent,
                vueCode: ExampleCode
            }
        }
    });
</script>